<template>
  <RevAccordionItem>
    <template #prefix>
      <IconCheckInCircle />
    </template>
    <template #title>
      {{ title }}
    </template>
    <template #body>
      <p class="body-1 whitespace-pre-line">
        {{ body }}
      </p>
    </template>
  </RevAccordionItem>
</template>

<script setup lang="ts">
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'

defineProps<{
  title: string
  body: string
}>()
</script>
